import QuestionModel from "./QuestionModel";

export default class QuestionModelStatic extends QuestionModel {
    constructor(module, type, view, input, range, template, difficulty) {
        super(module, type, view, input, range, template, difficulty);
    }
}